import type { EndpointSourceType } from '@terra/shared-schemas-orchestrator';

export const ENDPOINT_SOURCE_TRANSLATION_KEY_BY_VALUE = {
  TRACKING: 'tracking',
  CRAWLING: 'crawling',
  PROBING: 'probing',
  MANUAL: 'manual',
  COPILOT: 'copilot',
  AI: 'ai',
  FEATURE_ANALYSIS: 'featureAnalysis',
  NAVIGATION_PROFILE: 'navigationProfile',
  WIZ_INTEGRATION: 'wizIntegration',
  UPWIND_INTEGRATION: 'upwindIntegration',
} as const satisfies Record<EndpointSourceType, string>;
